import ngettext from '@eb/ngettext';

import {
    getFollowOrganizerStatus,
    getFollowCollectionStatus,
} from '@eb/destination-utils';

export const getUpcomingEventCopy = (numUpcomingEvents) =>
    ngettext('upcoming event', 'upcoming events', numUpcomingEvents);

const explicitOptIn = 1;
const explicitOptOut = 2;
const explicitChoices = [explicitOptIn, explicitOptOut];

export const hasAlreadyChosen = async (type, userId) => {
    let hasChosen = false;
    const getFollowStatus =
        type === 'organizer'
            ? getFollowOrganizerStatus
            : getFollowCollectionStatus;
    try {
        const response = await getFollowStatus(userId);
        hasChosen =
            explicitChoices.includes(
                response['preferences'][0]['global_preference'],
            ) &&
            explicitChoices.includes(
                response['preferences'][1]['global_preference'],
            );
    } catch (error) {
        // If the api fails we should still show the GDPR modal.
    }
    return !hasChosen;
};

export const shouldShowGDPRModal = async (
    type = 'organizer',
    isGDPRCountry = true,
    userId,
) => {
    if (!isGDPRCountry) {
        return false;
    } else {
        return hasAlreadyChosen(type, userId).then((resp) => resp);
    }
};
